import '../../../../shared/less/views/timer-confirmation-view.less';

import * as React from 'react';

import { translate } from '~l10n/client';

import { AlertMessage } from '../../../src/shared/components/AlertMessage/AlertMessage';
import { Spinner } from '../../../src/shared/components/Spinner/Spinner';
import { StaticTimerDisplay } from '../components/StaticTimerDisplay';

interface TimerConfirmationViewProps {
  timerSeconds: number;
  onStartClicked: () => Promise<void>;
  errorMessage?: string;
  isLoading?: boolean;
  onDismissError?: () => void;
}

export const TimerConfirmationView: React.FC<TimerConfirmationViewProps> = ({
  timerSeconds,
  onStartClicked,
  errorMessage,
  isLoading = false,
  onDismissError,
}) => {
  const timerMinutes = Math.floor(timerSeconds / 60);
  const headerText =
    timerMinutes === 1
      ? translate('You will have {0} minute to complete this activity').format(
          timerMinutes
        )
      : translate('You will have {0} minutes to complete this activity').format(
          timerMinutes
        );

  return (
    <div className="timer-confirmation-container">
      <div className="timer-confirmation-content">
        <div key="quiz-timer-container" className="quiz-timer-container">
          <StaticTimerDisplay timerSeconds={timerSeconds} />
        </div>
        <h2 className="timer-confirmation-title">{headerText}</h2>
        <p className="timer-confirmation-subtitle">
          {translate("Start when you're ready.")}
        </p>
        <button
          id="timer-confirmation-button"
          className="timer-confirmation-button"
          onClick={onStartClicked}
          disabled={isLoading}
          type="button"
        >
          {isLoading ? <Spinner size="small" /> : translate('Start')}
        </button>
        {errorMessage && (
          <AlertMessage
            tone="critical"
            showIcon={true}
            onClose={onDismissError}
            closeLabel={translate('Close error message')}
          >
            {errorMessage}
          </AlertMessage>
        )}
      </div>
    </div>
  );
};
